
		<div class="row">
			<div class="col-md-12">
				<cache-date></cache-date>
			</div>
			
			<div class="col-md-12">
				<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
			</div>
			
			<div class="col-md-12">
				<loading [isLoad]="statsLoader"></loading>
				
				<table class="table">
					<thead>
						<tr>
							<th>
								{{ 'adminstat.template.template' | translate }}
							</th>
	
							<th>
								{{ 'adminstat.common.siteCount' | translate }}
							</th>
	
							<th>
								
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let stat of stats; let i = index">
							<td>
								{{ stat.templateId }}
							</td>

							<td>
								{{ stat.count }}
							</td>
							
							<td>
								<ngb-accordion #acc="ngbAccordion">
									<ngb-panel
										[id]="'a' + i"
										title="{{ 'adminstat.common.site subjects' | translate }} ({{ stat.subjects.length }})"
									>
										<ng-template ngbPanelContent>
											<table class="table">
												<tbody>
													<tr *ngFor="let subject of stat.subjects">
														<td>
															{{ subject.subjectId }}
														</td>
								
														<td>
															{{ subject.count }}
														</td>
													</tr>
												</tbody>
											</table>
										</ng-template>
									</ngb-panel>
								</ngb-accordion>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

	